module.exports = __webpack_public_path__ + "static/img/sky.9d9ee3d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sky.jpg
// module id = ohbk
// module chunks = 1